import React, { useMemo } from 'react';

const YouTubeEmbed = ({ url, title = "YouTube video", className = "" }) => {
  // 从YouTube URL中提取视频ID
  const videoId = useMemo(() => {
    if (!url) return null;
    
    try {
      // 处理常见的YouTube链接格式
      let id = null;
      
      // 标准YouTube URL: https://www.youtube.com/watch?v=VIDEO_ID
      if (url.includes('youtube.com/watch')) {
        const urlParams = new URL(url).searchParams;
        id = urlParams.get('v');
      } 
      // 短YouTube URL: https://youtu.be/VIDEO_ID
      else if (url.includes('youtu.be/')) {
        id = url.split('youtu.be/')[1].split('?')[0];
      }
      // 嵌入式链接: https://www.youtube.com/embed/VIDEO_ID
      else if (url.includes('youtube.com/embed/')) {
        id = url.split('youtube.com/embed/')[1].split('?')[0];
      }
      
      return id;
    } catch (error) {
      console.error('Error parsing YouTube URL:', error);
      return null;
    }
  }, [url]);

  if (!videoId) {
    return null;
  }

  return (
    <div className={`youtube-embed-container ${className}`}>
      <iframe
        width="100%"
        height="315"
        src={`https://www.youtube.com/embed/${videoId}`}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default YouTubeEmbed;